var map = {
	"./af": 16,
	"./af.js": 16,
	"./ar": 23,
	"./ar-dz": 17,
	"./ar-dz.js": 17,
	"./ar-kw": 18,
	"./ar-kw.js": 18,
	"./ar-ly": 19,
	"./ar-ly.js": 19,
	"./ar-ma": 20,
	"./ar-ma.js": 20,
	"./ar-sa": 21,
	"./ar-sa.js": 21,
	"./ar-tn": 22,
	"./ar-tn.js": 22,
	"./ar.js": 23,
	"./az": 24,
	"./az.js": 24,
	"./be": 25,
	"./be.js": 25,
	"./bg": 26,
	"./bg.js": 26,
	"./bm": 27,
	"./bm.js": 27,
	"./bn": 28,
	"./bn.js": 28,
	"./bo": 29,
	"./bo.js": 29,
	"./br": 30,
	"./br.js": 30,
	"./bs": 31,
	"./bs.js": 31,
	"./ca": 32,
	"./ca.js": 32,
	"./cs": 33,
	"./cs.js": 33,
	"./cv": 34,
	"./cv.js": 34,
	"./cy": 35,
	"./cy.js": 35,
	"./da": 36,
	"./da.js": 36,
	"./de": 39,
	"./de-at": 37,
	"./de-at.js": 37,
	"./de-ch": 38,
	"./de-ch.js": 38,
	"./de.js": 39,
	"./dv": 40,
	"./dv.js": 40,
	"./el": 41,
	"./el.js": 41,
	"./en-SG": 42,
	"./en-SG.js": 42,
	"./en-au": 43,
	"./en-au.js": 43,
	"./en-ca": 44,
	"./en-ca.js": 44,
	"./en-gb": 45,
	"./en-gb.js": 45,
	"./en-ie": 46,
	"./en-ie.js": 46,
	"./en-il": 47,
	"./en-il.js": 47,
	"./en-nz": 48,
	"./en-nz.js": 48,
	"./eo": 49,
	"./eo.js": 49,
	"./es": 52,
	"./es-do": 50,
	"./es-do.js": 50,
	"./es-us": 51,
	"./es-us.js": 51,
	"./es.js": 52,
	"./et": 53,
	"./et.js": 53,
	"./eu": 54,
	"./eu.js": 54,
	"./fa": 55,
	"./fa.js": 55,
	"./fi": 56,
	"./fi.js": 56,
	"./fo": 57,
	"./fo.js": 57,
	"./fr": 60,
	"./fr-ca": 58,
	"./fr-ca.js": 58,
	"./fr-ch": 59,
	"./fr-ch.js": 59,
	"./fr.js": 60,
	"./fy": 61,
	"./fy.js": 61,
	"./ga": 62,
	"./ga.js": 62,
	"./gd": 63,
	"./gd.js": 63,
	"./gl": 64,
	"./gl.js": 64,
	"./gom-latn": 65,
	"./gom-latn.js": 65,
	"./gu": 66,
	"./gu.js": 66,
	"./he": 67,
	"./he.js": 67,
	"./hi": 68,
	"./hi.js": 68,
	"./hr": 69,
	"./hr.js": 69,
	"./hu": 70,
	"./hu.js": 70,
	"./hy-am": 71,
	"./hy-am.js": 71,
	"./id": 72,
	"./id.js": 72,
	"./is": 73,
	"./is.js": 73,
	"./it": 75,
	"./it-ch": 74,
	"./it-ch.js": 74,
	"./it.js": 75,
	"./ja": 76,
	"./ja.js": 76,
	"./jv": 77,
	"./jv.js": 77,
	"./ka": 78,
	"./ka.js": 78,
	"./kk": 79,
	"./kk.js": 79,
	"./km": 80,
	"./km.js": 80,
	"./kn": 81,
	"./kn.js": 81,
	"./ko": 82,
	"./ko.js": 82,
	"./ku": 83,
	"./ku.js": 83,
	"./ky": 84,
	"./ky.js": 84,
	"./lb": 85,
	"./lb.js": 85,
	"./lo": 86,
	"./lo.js": 86,
	"./lt": 87,
	"./lt.js": 87,
	"./lv": 88,
	"./lv.js": 88,
	"./me": 89,
	"./me.js": 89,
	"./mi": 90,
	"./mi.js": 90,
	"./mk": 91,
	"./mk.js": 91,
	"./ml": 92,
	"./ml.js": 92,
	"./mn": 93,
	"./mn.js": 93,
	"./mr": 94,
	"./mr.js": 94,
	"./ms": 96,
	"./ms-my": 95,
	"./ms-my.js": 95,
	"./ms.js": 96,
	"./mt": 97,
	"./mt.js": 97,
	"./my": 98,
	"./my.js": 98,
	"./nb": 99,
	"./nb.js": 99,
	"./ne": 100,
	"./ne.js": 100,
	"./nl": 102,
	"./nl-be": 101,
	"./nl-be.js": 101,
	"./nl.js": 102,
	"./nn": 103,
	"./nn.js": 103,
	"./pa-in": 104,
	"./pa-in.js": 104,
	"./pl": 105,
	"./pl.js": 105,
	"./pt": 107,
	"./pt-br": 106,
	"./pt-br.js": 106,
	"./pt.js": 107,
	"./ro": 108,
	"./ro.js": 108,
	"./ru": 109,
	"./ru.js": 109,
	"./sd": 110,
	"./sd.js": 110,
	"./se": 111,
	"./se.js": 111,
	"./si": 112,
	"./si.js": 112,
	"./sk": 113,
	"./sk.js": 113,
	"./sl": 114,
	"./sl.js": 114,
	"./sq": 115,
	"./sq.js": 115,
	"./sr": 117,
	"./sr-cyrl": 116,
	"./sr-cyrl.js": 116,
	"./sr.js": 117,
	"./ss": 118,
	"./ss.js": 118,
	"./sv": 119,
	"./sv.js": 119,
	"./sw": 120,
	"./sw.js": 120,
	"./ta": 121,
	"./ta.js": 121,
	"./te": 122,
	"./te.js": 122,
	"./tet": 123,
	"./tet.js": 123,
	"./tg": 124,
	"./tg.js": 124,
	"./th": 125,
	"./th.js": 125,
	"./tl-ph": 126,
	"./tl-ph.js": 126,
	"./tlh": 127,
	"./tlh.js": 127,
	"./tr": 128,
	"./tr.js": 128,
	"./tzl": 129,
	"./tzl.js": 129,
	"./tzm": 131,
	"./tzm-latn": 130,
	"./tzm-latn.js": 130,
	"./tzm.js": 131,
	"./ug-cn": 132,
	"./ug-cn.js": 132,
	"./uk": 133,
	"./uk.js": 133,
	"./ur": 134,
	"./ur.js": 134,
	"./uz": 136,
	"./uz-latn": 135,
	"./uz-latn.js": 135,
	"./uz.js": 136,
	"./vi": 137,
	"./vi.js": 137,
	"./x-pseudo": 138,
	"./x-pseudo.js": 138,
	"./yo": 139,
	"./yo.js": 139,
	"./zh-cn": 140,
	"./zh-cn.js": 140,
	"./zh-hk": 141,
	"./zh-hk.js": 141,
	"./zh-tw": 142,
	"./zh-tw.js": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;


//////////////////
// WEBPACK FOOTER
// C:/Users/小梁/Desktop/reservation_server/web/~/moment/locale ^\.\/.*$
// module id = 160
// module chunks = 3